import api from './api';

export interface AvailableWeight {
  id: number;
  value: string;
}

export interface Equipment {
  id: number;
  name: string;
  imageUrl: string;
  group: {
    id: number;
    name: string;
  };
  type: string;
  targetMuscles: {
    id: number;
    name: string;
    imageUrl: string;
    darkImageUrl: string | null;
  }[];
  availableWeights: AvailableWeight[];
}

interface EquipmentResponse {
  data: Equipment[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const getEquipments = async (page: number = 1, limit: number = 10): Promise<EquipmentResponse> => {
  try {
    const response = await api.get<EquipmentResponse>('/equipment', {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching equipment:', error);
    throw error;
  }
};

export const getAllEquipments = async (): Promise<Equipment[]> => {
  try {
    const response = await api.get<{ data: Equipment[] }>('/equipment');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching equipment:', error);
    throw error;
  }
};

export const createEquipment = async (data: Partial<Equipment> | FormData): Promise<Equipment> => {
  try {
    const headers = data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/json' };
    const response = await api.post<Equipment>('/equipment', data, { headers });
    return response.data;
  } catch (error) {
    console.error('Error creating equipment:', error);
    throw error;
  }
};


export const updateEquipment = async (id: number, data: Partial<Equipment>): Promise<Equipment> => {
  try {
    const response = await api.patch<Equipment>(`/equipment/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating equipment:', error);
    throw error;
  }
};

export const deleteEquipment = async (id: number): Promise<void> => {
  try {
    const response = await api.delete(`/equipment/${id}`);
    if (response.status !== 200) {
      throw new Error('Failed to delete equipment');
    }
  } catch (error) {
    console.error('Error deleting equipment:', error);
    throw error;
  }
};

export interface EquipmentGroup {
  id: number;
  name: string;
  imageUrl: string;
}

export const getEquipmentGroups = async (): Promise<EquipmentGroup[]> => {
  try {
    const response = await api.get<EquipmentGroup[]>('/equipment-groups');
    return response.data;
  } catch (error) {
    console.error('Error fetching equipment groups:', error);
    throw error;
  }
};
